import Error from "./Error";

export const ErrorBoundary = () => {
    return <Error isErrorBoundary />;
};
